export const LOGGED_IN_LAYOUT_ID = 'logged-in-layout';
